import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const VerticalAnimationContainer = styled.div<React.CSSProperties>`
  margin: 0;
  padding: 0;
`;

export default withAnimation(VerticalAnimationContainer);
